import { render, staticRenderFns } from "./StaffNew.vue?vue&type=template&id=90161144&scoped=true&"
import script from "./StaffNew.vue?vue&type=script&lang=js&"
export * from "./StaffNew.vue?vue&type=script&lang=js&"
import style0 from "./StaffNew.vue?vue&type=style&index=0&id=90161144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90161144",
  null
  
)

export default component.exports